import styled from "styled-components"
import React from "react"
import { Bars, ChevronDownIcon } from "client/components"


export const ParagraphCollapseWrapper = styled.div<React.HTMLAttributes<HTMLDivElement>>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    margin-top: 5px;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    color: ${(props) => props.theme.nestedListParagraphCollapseColor};
    transform: rotate(0);
    transition: ${(props) => props.theme.defaultTransition};
`
export const ParagraphCollapseControl = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <ParagraphCollapseWrapper {...props}>
        <ChevronDownIcon />
    </ParagraphCollapseWrapper>
)


export const Paragraph = styled.div`
    display: flex;
`
export const ParagraphDetails = styled.div`
    display: flex;
    flex-grow: 1;
    padding: 4px 8px;
    border: 1px solid ${(props) => props.theme.nestedListParagraphBorderColor};
    background: ${(props) => props.theme.nestedListParagraphBackground};
    border-left: none;
    border-radius: 2px;
`
export const ParagraphTitle = styled.span`
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 22px;
    cursor: default;
    user-select: none;
`
export const ParagraphContent = styled.div<{
    offsetLeft: boolean
}>`
    padding-left: ${(props) => (props.offsetLeft ? "20px" : "0")};
    overflow: hidden;
    height: auto;
    opacity: 1;
    pointer-events: all;
    transition: 0.5s ease;
`
export const ParagraphListWrapper = styled.div`
    &.disabled {
        pointer-events: none;
        opacity: 0.7;
    }
`
export const ParagraphWrapper = styled.div`
    margin-top: 5px;
    margin-bottom: 25px;

    &:last-child {
        margin-bottom: 0;
    }

    &.collapsed {
        margin-bottom: 0;

        & > ${Paragraph} > ${ParagraphCollapseWrapper} {
            transform: rotate(-90deg);
        }

        & > ${ParagraphContent} {
            height: 0;
            opacity: 0;
            pointer-events: none;
        }
    }

    &.drag-item {
        position: absolute;
        pointer-events: none;
        z-index: 1000;
    }

    &.ghost {
        margin-bottom: 0;
        opacity: 0.5;

        ${ParagraphContent} {
            display: none;
        }
    }
`

export const ItemListWrapper = styled.div`
    padding-left: 20px;
`
export const ItemWrapper = styled.div`
    &:first-child {
        margin-top: 6px;
    }

    &:last-child {
        margin-bottom: 6px;
    }

    &.drag-item {
        position: absolute;
        pointer-events: none;
        z-index: 1000;
    }

    &.ghost {
        opacity: 0.5;

        & > ${ItemListWrapper} {
            display: none;
        }
    }
`
export const Item = styled.div`
    display: flex;
    padding: 4px 8px;
    margin-top: -1px; /* to hide double-border */
    border: 1px solid ${(props) => props.theme.nestedListItemBorderColor};
    border-radius: 2px;
    background: ${(props) => props.theme.nestedListItemBackgroundColor};
`
export const ItemDetails = styled.div`
    display: flex;
    flex-grow: 1;
    font-size: 13px;
    cursor: default;
    user-select: none;
`
export const ItemPublicId = styled.span`
    font-weight: 700;
    margin-right: 15px;
`
export const ItemData = styled.span`
`


const MenuButtonWrapper = styled.div`
    width: 16px;
    height: 20px;
    padding-right: 2px;
    margin-right: 8px;
    cursor: pointer;
    color: ${(props) => props.theme.nestedListMenuButtonColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.nestedListMenuButtonColorHover};
    }
`
export const MenuButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <MenuButtonWrapper {...props}>
        <Bars />
    </MenuButtonWrapper>
)
